import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ControlContainer, UntypedFormBuilder} from "@angular/forms";

@Component({
  selector: 'app-peptide-similarity-formgroup',
  templateUrl: './peptide-similarity-formgroup.component.html',
  styleUrls: ['./peptide-similarity-formgroup.component.scss']
})
export class PeptideSimilarityFormgroupComponent {
  @Input() modelIndex: number | any;
  @Input() disabled: boolean | any;
  @Input() predictionOption: {
    display_name: string,
    short_name: string,
    group: string,
    source: string,
    has_ic50: boolean
  }[] = [];

  @Output() emitPredictionModelIndex = new EventEmitter<number>();
  public ogFormGroup: any = null;

  constructor(
    public controlContainer: ControlContainer,
    private fb: UntypedFormBuilder
  ) {
  }

  ngOnInit(): void {
    this.ogFormGroup = this.controlContainer.control;
  }

  onCancelClick() {
    this.emitPredictionModelIndex.emit(this.modelIndex);
  }
}
